import { useAppDispatch, useAppSelector } from '@/Hooks/useAppRedux'
import { unpinAllChannelPost } from '@/Redux/slices/VodSlice';
import { Button, Input, Modal, Table } from 'antd';
import React, { useState } from 'react'

interface ModalProps {
  isModalVisible: boolean;
  setModalVisible: (visible: boolean) => void;
}

interface reviewChannel {
  name: string,
  id: number,
}

enum ModalMode {
  Input, Review
}

const UnpinChannelModal = ({isModalVisible, setModalVisible}: ModalProps) => {
  const dispatch = useAppDispatch();
  const channels = useAppSelector((state) => state.vod.value);
  const [channelIdList, setChannelIdList] = useState([
    {
      key: 0,
      channelId: '',
    },]);
  const [reviewChannelList, setReviewChannelList] = useState([] as reviewChannel[])
  const [mode, setMode] = useState(ModalMode.Input);
  const [errorList, setErrorList] = useState([] as number[]);

  const column = [
    {
      title: 'No. ',
      dataIndex: 'key',
      key: 'key',
      width: 56,
      render: (key: number) => (
        <div>{key + 1}</div>
      )
    },
    {
      title: 'Channel ID',
      dataIndex: 'key',
      key: 'channel',
      render: (key: number) => (
        <div>
          <Input
            allowClear
            status={errorList.includes(key) ? 'error' : ''}
            value={channelIdList[key].channelId}
            onChange={(e: React.ChangeEvent) => {
              const target = e.target as HTMLInputElement;
              updateChannelIdListByKey(key, target.value);
            }}
          />
        </div>
        

      ),
    },
    {
      title: '',
      dataIndex: 'key',
      key: 'delete',
      render: (key: number) => (
        <Button
          type="primary" 
          danger
          onClick={() => deleteRow(key)}
          disabled={key === 0 && channelIdList.length == 1}
        >
          Delete
        </Button>
      )
    }
  ]

  const reviewColumn = [
    {
      title: 'Channel ID',
      dataIndex: 'id',
      key: 'id',
      width: 105,
    },
    {
      title: 'Channel Name',
      dataIndex: 'name',
      key: 'name'
    }
  ]

  const onConfirmClick = () => {
    const request = reviewChannelList.map((data) => data.id);
    dispatch(unpinAllChannelPost(request));
    setReviewChannelList([]);
    setErrorList([]);
    setMode(ModalMode.Input)
    setChannelIdList([
    {
      key: 0,
      channelId: '',
    },]);
    setModalVisible(false);
  }

  const onReviewClick = () => {
    let unknownIdList: number[] = [];
    const channelMapList = channelIdList.map((channelId) => {
      const foundChannel = channels.channels.find((channel) => channel.channelId.toString() == channelId.channelId);
      if (foundChannel == undefined || !foundChannel.disabled) {
        unknownIdList.push(channelId.key);
        return null
      } else {
        return {
          name: foundChannel.channelName,
          id: foundChannel.channelId
        }
      }
    }).filter((e) => e != null);
    setErrorList([...unknownIdList]);
    if (unknownIdList.length == 0)
    {
      setReviewChannelList(channelMapList);
      setMode(ModalMode.Review);
    }
    
  }

  const onCancelClick = () => {
    setModalVisible(false);
    setErrorList([]);
    setReviewChannelList([]);
    setChannelIdList([]);
    setMode(ModalMode.Input)
    setChannelIdList([
      {
        key: 0,
        channelId: '',
      },]
    );
  }

  const onReviewCancelClick = () => {
    setMode(ModalMode.Input)
  }

  const addUnpinChannelRow = (row: number) => {
    setChannelIdList((prevChannelIdList) => [
      ...prevChannelIdList,
      {
        key: row,
        channelId: '',
      },
    ]);
  }

  const deleteRow = (row: number) => {
    let tempList = channelIdList;
    tempList.splice(row, 1);
    tempList = tempList.map((data) => ({ 
      key: data.key > row ? data.key - 1 : data.key, 
      channelId: data.channelId
    }))
    console.log(tempList)
    setChannelIdList([...tempList]);
  }

  const updateChannelIdListByKey = (key: number, id: any) => {
    const tempList = channelIdList;
    const newIndex = tempList.findIndex((e) => e.key === key);
    tempList[newIndex].channelId = id;
    setChannelIdList([...tempList]);
  }

  return (
    <Modal
      title={mode === ModalMode.Input ? "Unpin Channels Video" : "Confirm unpin all videos from below selected channels"}
      open={isModalVisible}
      closable
      onCancel={mode === ModalMode.Input ? onCancelClick : onReviewCancelClick}
      okText={mode === ModalMode.Input ? "Review" : "Confirm"}
      onOk={mode === ModalMode.Input ? onReviewClick : onConfirmClick}
      okButtonProps={{
        disabled: channelIdList.length <= 1 && channelIdList[0].channelId.length == 0,
        danger: mode === ModalMode.Review
      }}
    >
      {
        mode === ModalMode.Input ? (
          <div className="h-auto bg-white p-6 pb-2">
            <div className="flex justify-end">
              <Button
                type="primary"
                onClick={() => addUnpinChannelRow(channelIdList.length)}
              >
                Add Channel
              </Button>
            </div>
            <Table 
              className='mt-4'
              columns={column}
              dataSource={channelIdList.map((data) => ({
                key: data.key
              }))}
              pagination={false}
            />
            <p className='text-red-500'>*Only Disabled Channel can be selected</p>
          </div>
        ) : (
          <div>
            <Table
              className="mt-4"
              columns={reviewColumn}
              dataSource={reviewChannelList.map((data) => ({
                id: data.id,
                name: data.name
              }))}
              pagination={false}
            />
            <p className='text-red-500'>*Changes cannot be undone</p>
          </div>
        )
      }
    </Modal>
  )
}

export default UnpinChannelModal;